// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found_container__lMmoT","grid":"not-found_grid__BGQqW","content":"not-found_content__krn5k","text":"not-found_text__nt3g9","buttons":"not-found_buttons__vXWDn"};